import React from 'react';
import { isEditor } from '../../utils/isEditor.js';
import HomeSaleProceedsCalculator from './HomeSaleProceedsCalculator.js';
import { FieldConfig } from './HomeSaleProceedsCalculator.utils.js';

var _attributes;
var HomeSaleProceedsCalculatorBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var desiredSellingPrice = attrs.desiredSellingPrice,
      remainingMortgageOwed = attrs.remainingMortgageOwed,
      homeImprovement = attrs.homeImprovement,
      cleaningAndPrep = attrs.cleaningAndPrep,
      monthlyMortgagePayments = attrs.monthlyMortgagePayments,
      moving = attrs.moving,
      agentCommission = attrs.agentCommission,
      sellingConcessions = attrs.sellingConcessions,
      closingFees = attrs.closingFees,
      taxes = attrs.taxes;
    var defaultValues = {
      desiredSellingPrice: desiredSellingPrice,
      remainingMortgageOwed: remainingMortgageOwed,
      homeImprovement: homeImprovement,
      cleaningAndPrep: cleaningAndPrep,
      monthlyMortgagePayments: monthlyMortgagePayments,
      moving: moving,
      agentCommission: agentCommission,
      sellingConcessions: sellingConcessions,
      closingFees: closingFees,
      taxes: taxes
    };
    return /*#__PURE__*/React.createElement(HomeSaleProceedsCalculator, {
      key: isEditor() ? JSON.stringify(defaultValues) : undefined,
      defaultValues: defaultValues
    });
  },
  metadata: {
    version: '1.0',
    name: 'constellation/home-sale-proceeds-calculator',
    title: 'Home Sale Proceeds Calculator',
    description: 'Estimates how much money you will make selling your home.',
    icon: 'calculator',
    keywords: ['home', 'sale', 'proceeds', 'calculator'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'more',
    attributes: (_attributes = {}, _attributes[FieldConfig.desiredSellingPrice.name] = {
      type: 'number',
      default: 302000,
      label: 'Selling price & mortgage : default desired selling price',
      control: 'number'
    }, _attributes[FieldConfig.remainingMortgageOwed.name] = {
      type: 'number',
      default: 0,
      label: 'Selling price & mortgage : default remaining mortgage owed',
      control: 'number'
    }, _attributes[FieldConfig.homeImprovement.name] = {
      type: 'number',
      label: 'Est. prep & repair costs : default home improvement',
      default: 0,
      control: 'number'
    }, _attributes[FieldConfig.cleaningAndPrep.name] = {
      type: 'number',
      label: 'Est. prep & repair costs : default cleaning and prep',
      default: 6000,
      control: 'number'
    }, _attributes[FieldConfig.monthlyMortgagePayments.name] = {
      type: 'number',
      default: 0,
      label: 'Est. on-market costs : default monthly mortgage payments',
      control: 'number'
    }, _attributes[FieldConfig.moving.name] = {
      type: 'number',
      default: 1600,
      label: 'Est. on-market costs: default moving',
      control: 'number'
    }, _attributes[FieldConfig.agentCommission.name] = {
      type: 'number',
      default: 0,
      label: 'Est. closing costs: default agent commission',
      control: 'number'
    }, _attributes[FieldConfig.sellingConcessions.name] = {
      type: 'number',
      default: 0,
      label: 'Est. closing costs: default selling concessions',
      control: 'number'
    }, _attributes[FieldConfig.closingFees.name] = {
      type: 'number',
      default: 0,
      label: 'Est. closing costs: default closing fees',
      control: 'number'
    }, _attributes[FieldConfig.taxes.name] = {
      type: 'number',
      default: 0,
      label: 'Est. closing costs: default taxes',
      control: 'number'
    }, _attributes)
  }
};
var HomeSaleProceedsCalculatorBlock$1 = HomeSaleProceedsCalculatorBlock;

export { HomeSaleProceedsCalculatorBlock$1 as default };
